import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-bar-top" }
const _hoisted_2 = {
  key: 0,
  class: "user-avatar-wrap"
}
const _hoisted_3 = ["src", "onClick"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_DepositBtn = _resolveComponent("DepositBtn")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.userID)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_UserAvatar, {
            avatar: _ctx.avatar,
            userID: _ctx.userID
          }, null, 8, ["avatar", "userID"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DepositBtn, {
      class: "deposit-btn-wrap",
      size: 18
    }),
    _createVNode(_component_router_link, {
      custom: "",
      to: "/"
    }, {
      default: _withCtx(({ navigate }) => [
        _createElementVNode("img", {
          src: require('../../assets/icons/logo.svg'),
          onClick: navigate,
          class: "logo-horizontal-wrap"
        }, null, 8, _hoisted_3)
      ]),
      _: 1
    }),
    (!_ctx.userID)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/auth",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createVNode(_component_BaseButton, {
              class: "base-button-wrap auth-btn primary b-14 lg",
              onClick: navigate
            }, {
              left: _withCtx(() => [
                _createElementVNode("img", {
                  src: require('../../assets/icons/steam.svg')
                }, null, 8, _hoisted_4)
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(_ctx.t('MiniProfile.signin')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.userID)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: "/logout",
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("div", {
              class: "logout-btn",
              onClick: navigate
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none"
              }, [
                _createElementVNode("path", {
                  d: "M11.5408 11.9167L9.43242 14.0158C9.3465 14.1011 9.27831 14.2024 9.23177 14.3141C9.18523 14.4259 9.16127 14.5457 9.16127 14.6667C9.16127 14.7877 9.18523 14.9075 9.23177 15.0192C9.27831 15.1309 9.3465 15.2323 9.43242 15.3175C9.51763 15.4034 9.61902 15.4716 9.73072 15.5182C9.84243 15.5647 9.96224 15.5887 10.0833 15.5887C10.2043 15.5887 10.3241 15.5647 10.4358 15.5182C10.5475 15.4716 10.6489 15.4034 10.7341 15.3175L14.4008 11.6508C14.4842 11.5637 14.5496 11.4609 14.5933 11.3483C14.6849 11.1252 14.6849 10.8748 14.5933 10.6517C14.5496 10.5392 14.4842 10.4364 14.4008 10.3492L10.7341 6.68251C10.6486 6.59704 10.5471 6.52924 10.4355 6.48299C10.3238 6.43673 10.2041 6.41293 10.0833 6.41293C9.96238 6.41293 9.84269 6.43673 9.73102 6.48299C9.61935 6.52924 9.51789 6.59704 9.43242 6.68251C9.34695 6.76798 9.27915 6.86944 9.2329 6.98111C9.18664 7.09278 9.16283 7.21247 9.16283 7.33334C9.16283 7.45421 9.18664 7.5739 9.2329 7.68557C9.27915 7.79724 9.34695 7.89871 9.43242 7.98418L11.5408 10.0833H2.74992C2.5068 10.0833 2.27365 10.1799 2.10174 10.3518C1.92983 10.5237 1.83325 10.7569 1.83325 11C1.83325 11.2431 1.92983 11.4763 2.10174 11.6482C2.27365 11.8201 2.5068 11.9167 2.74992 11.9167H11.5408ZM10.9999 1.83334C9.28675 1.82569 7.60573 2.29829 6.14751 3.19752C4.6893 4.09675 3.51227 5.38663 2.74992 6.92084C2.64052 7.13965 2.62252 7.39295 2.69987 7.62502C2.77723 7.8571 2.94361 8.04894 3.16242 8.15834C3.38122 8.26774 3.63452 8.28575 3.8666 8.20839C4.09868 8.13103 4.29052 7.96465 4.39992 7.74584C4.97943 6.57555 5.86093 5.58124 6.95334 4.86567C8.04574 4.15009 9.30942 3.7392 10.6138 3.67547C11.9181 3.61174 13.2158 3.89747 14.3728 4.50314C15.5298 5.10882 16.504 6.01245 17.1949 7.12067C17.8857 8.22889 18.2681 9.50149 18.3025 10.8069C18.3368 12.1124 18.022 13.4034 17.3905 14.5464C16.7589 15.6895 15.8336 16.6432 14.7102 17.3089C13.5867 17.9746 12.3058 18.3283 10.9999 18.3333C9.63306 18.3393 8.29223 17.9597 7.1313 17.2382C5.97038 16.5166 5.03641 15.4824 4.43659 14.2542C4.32718 14.0354 4.13534 13.869 3.90327 13.7916C3.67119 13.7143 3.41789 13.7323 3.19909 13.8417C2.98028 13.9511 2.8139 14.1429 2.73654 14.375C2.65918 14.6071 2.67718 14.8604 2.78659 15.0792C3.51334 16.5417 4.61765 17.7836 5.98527 18.6762C7.35289 19.5689 8.93416 20.08 10.5655 20.1566C12.1969 20.2332 13.8191 19.8726 15.2644 19.1121C16.7097 18.3515 17.9255 17.2187 18.7861 15.8307C19.6468 14.4427 20.121 12.85 20.1597 11.2173C20.1984 9.58456 19.8002 7.97115 19.0063 6.54394C18.2124 5.11673 17.0516 3.92753 15.644 3.09936C14.2364 2.27118 12.6331 1.83411 10.9999 1.83334Z",
                  fill: "currentColor"
                })
              ], -1)
            ]))], 8, _hoisted_5)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}